


















import BtnList from 'library/components/globals/btn-list'

export default
	components: { BtnList }

	# When rerouting (a link is clicked) make sure to close the modal
	watch:
		'$route.path': -> @$refs.modal.close()

	props:
		body:	String
		buttons: Array

